module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-ba"
  }, [_c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0006-01.jpg",
      "width": "442"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapf",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "id": "index1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "orange"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "index2"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("t’s an odd way to start a cookbook, I know. But I have to say it: I never set out to be a maple syrup producer. It’s not something a private equity executive would think to do, especially one who spent the majority of his career investing in power and energy infrastructure. But little did I know that maple syrup—one of the most revered natural food products available today—would challenge me to think like an energy innovator, to be resourceful with science and respectful of a tradition that not only predates me, but predates almost every kind of food technology. To me, maple syrup isn’t just a food; it’s a natural resource—an edible bounty created in a self-sustaining environment, alone in a world of easily depleted resources, where vast swaths of forest have been bulldozed to make way for industrial spaces. But buildings don’t produce food; plants do. In that sense, maple syrup is the most American of products, a food sourced straight from nature that demands we use our modern technology to properly unlock it from the untamed wilderness. It’s a seemingly simple yet profoundly sophisticated delicacy, and I fell in love with this hobby and the challenge it presented: to apply my modern sense of business, science, and technology to the oldest and most beautiful of American foods.")])]), _c('a', {
    attrs: {
      "id": "index2"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index2"
    }
  }), _c('a', {
    attrs: {
      "id": "index3"
    }
  }, [_vm._v("I wish I could say I saw the possibilities of maple syrup from the very start, that I purchased huge tracts of land in eastern Dutchess County, New York simply to build my own sugar shack. But that could hardly be further from the truth. In fact, I bought the first patch of land for pure pleasure, a weekend country retreat for my wife, Lydia, and our growing daughters, Madeline and Ava. Though we were living in suburban New Jersey at the time, and have always loved spending time in nearby Manhattan, I am still a farm kid at heart. I grew up in Forreston, a small town of about twelve hundred people outside Rockford, Illinois, where agriculture was the primary business. My dad made his living that way—he was a veterinarian who raised livestock, mostly pigs, and ultimately bought half a dozen farms across the region, where he grew corn and soybeans. This is before the era of commodity crops; this was food grown for eating, and for spreading to livestock, and the revenue was intended to go back into the farm. As a boy, I was expected to work on the farm as well—and when I wasn’t roaming the streams and patches of forest for fun, I was at work feeding the pigs, cleaning their pens, and mucking out our stores of hay. I was at home in the countryside, in the wild, and would often go out on vet calls with my dad as he visited animals on other farms.")])]), _c('a', {
    attrs: {
      "id": "index3"
    }
  }), _c('div', {
    staticClass: "group-ba"
  }, [_c('a', {
    attrs: {
      "id": "index3"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "index3"
    }
  }), _c('a', {
    attrs: {
      "id": "index4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0007-01.jpg",
      "width": "414"
    }
  })])]), _c('a', {
    attrs: {
      "id": "index4"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "index4"
    }
  }), _c('a', {
    attrs: {
      "id": "index5"
    }
  }, [_c('em', [_vm._v("Maybe I was destined to work with maple syrup—after all, I spent much of my infancy just a little bit sticky")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "index5"
    }
  })]), _c('a', {
    attrs: {
      "id": "index5"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index5"
    }
  }), _c('a', {
    attrs: {
      "id": "index6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("I left my bucolic background to make a career in finance, so Lydia and I could raise our family, but after almost three decades away from nature, memories of my semiwild childhood drew me back to my roots. I knew I wanted to get my family reacquainted with the natural wonders of a noncity life while I still had the health and resources to enjoy it. We bought the first part of our property in Dover Plains, a mountain-studded area of Dutchess County, in 2007, on a 450-acre plot of stunning, untouched woods on which we intended to renovate a small getaway cabin with plans for a later, larger house. This plot of land had belonged to John Mack, a friend and political confidant of President Franklin D. Roosevelt. We suspect from old newspaper stories that FDR spent leisure time here trout fishing and bird-watching with his friend and former colleague.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index7"
    }
  }, [_vm._v("When John died, the land was then passed on to family members, who eventually contemplated a housing development. That’s where we came in. After buying our initial plot from Mack’s descendants, we learned that developers were also courting other neighbors. I didn’t know how much land I wanted, but I knew I loved the expansive untouched forest too much to see it torn down in favor of construction trailers and later McMansions. So as each new lot came on the market, I bought it. In just a year and a half, we had accumulated eight hundred acres. What started as a family estate soon gave me a new mission; I was buying land like a baron, but thinking like an environmentalist. This was going to be our sanctuary, a place where my school-aged kids and eventually their kids could run wild in nature the same way I had, and I wanted to keep it as intact as possible. Perhaps it’s a selfish motivation, but it’s the one I had.")])]), _c('a', {
    attrs: {
      "id": "index7"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index7"
    }
  }), _c('a', {
    attrs: {
      "id": "index8"
    }
  }, [_vm._v("When I first bought the acres of forest that would become Madava Farms, I didn’t even know what I’d bought into until we were already well into construction projects. I’d been working with a neighbor to construct some new pathways around the property and a bridge over the trout stream, as the few that remained had been there since the early 1800s. This neighbor had lived near my woods for many years and, after two years of having me in the neighborhood, asked what I intended to do with the maple trees on the property. Well, what "), _c('em', [_vm._v("could")]), _vm._v(" I do with them? Could I actually be a maple syrup producer? I dove into finding out—I was thinking of the land as “God’s country,” and once I discovered the fact that we were sitting on a nearly pristine plot of twenty-five thousand trees, it felt even more so.")])]), _c('a', {
    attrs: {
      "id": "index8"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index8"
    }
  }), _c('a', {
    attrs: {
      "id": "index9"
    }
  }, [_vm._v("After an initial six-month review period, in which we confirmed that we could indeed use our property as a world-class maple operation, we asked ourselves, “How is it we’re just sitting on this richness, and what are we doing, hogging it all to ourselves?” I began asking questions of the friendly band of maple syrup producers throughout New York and New England, as well as the brilliant advisors at the maple research center at Cornell University. What would it take for us to tap into—pun very much intended—this natural resource and still keep the land as wild and beautiful as we found it? How could we make sure our syrup was the best possible quality? Would we be able to sell such a large quantity of product?")])]), _c('a', {
    attrs: {
      "id": "index9"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index9"
    }
  }), _c('a', {
    attrs: {
      "id": "index10"
    }
  }, [_vm._v("I learned an enormous amount in those early days, about how the trees would best be tapped and still maintained, and about the essential technology needed to purify and preserve the syrup in its most natural form. I was equally intrigued by the void in the retail marketplace. There is, after all, no one name-brand syrup company in this market—none that truly produces pure maple, anyway. If our biggest shelf space competitors wouldn’t even be "), _c('em', [_vm._v("real")]), _vm._v(" maple syrup, but instead table syrups with artificial flavoring and only the tiniest amount of maple, if any, mixed in, then we had a real opportunity to break open this entire industry.")])]), _c('a', {
    attrs: {
      "id": "index10"
    }
  }), _c('div', {
    staticClass: "group-ba"
  }, [_c('a', {
    attrs: {
      "id": "index10"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "index10"
    }
  }), _c('a', {
    attrs: {
      "id": "index11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0009-01.jpg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "index12"
    }
  }, [_c('em', [_vm._v("When we’re putting in our taps, we’re riding on faith that the sap will flow—though exactly when, we cannot be sure")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "index12"
    }
  })]), _c('a', {
    attrs: {
      "id": "index12"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index12"
    }
  }), _c('a', {
    attrs: {
      "id": "index13"
    }
  }, [_vm._v("Our greatest realization about the consumer marketplace potential came from Lydia. As she experimented in the kitchen with our extremely pure syrups and sugar, she felt it was the most flavorful sweetener she had ever used in her cooking. The applications were almost endless. We wanted others to discover our syrup and put it to use, and not just enjoy it with their pancakes. If we were going to help maple more broadly break into the food marketplace, we wanted to do it right: to introduce people to maple syrup by giving them something well beyond the artificial syrup they were used to and expand their overall appreciation of what a pure food can taste like when prepared in the very best way possible.")])]), _c('a', {
    attrs: {
      "id": "index13"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index13"
    }
  }), _c('a', {
    attrs: {
      "id": "index14"
    }
  }, [_vm._v("Every year when we’re getting ready to tap our sugar maples, we’re going into it a bit blind. While we can set up our taps well in advance of the sap flowing, we never know exactly which day will be the first to yield sap. The trees give when they’re ready, so we have to respond to their needs—that’s our business model, paying attention to and learning from the land, not forcing the land to our will. I never set out to be a businessman in the maple syrup industry—and I still consider it a hobby—but I ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("did love the idea that this could be my family’s way to give back: to create a new and sustainable food business, to introduce consumers to an old product, and to put my years of work in the energy business to use in a completely new way. In meetings with Michael Farrell, director of Cornell’s Sugar Maple Research and Extension Field Station, I learned that if we directed our resources to maintaining the sugarbush as we tapped, we’d not only keep the forest and all its natural wildlife safe, but also ensure that the forest would be taken care of properly for many centuries to come. We’ve tried to keep the ecosystem of Madava intact, and in return the trees give us some of the sweetest, purest sap for syrup imaginable—the very best kind of reward. I was also becoming acutely aware of what this would mean to the surrounding community of the Hudson Valley. Opening a large maple syrup operation would mean jobs, many of them, for people who had made Dutchess County their home. By opening up the land as an agricultural business, it meant that we could no longer use it as our own private hideaway, and for a moment that did give me pause. Was I going to lose my ability to protect the land, which was the whole reason we bought it to begin with? "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("But then I knew that by owning this profoundly local and natural business, our family could play a role in helping bring a whole community back to life, and suddenly my wish for a sanctuary didn’t seem so important anymore. Maple syrup wasn’t a project for me to retire on; it was a project that would inspire our family, and does inspire us, every day.")]), _vm._v(" "), _c('div', {
    staticClass: "group-ba"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "index15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0010-01.jpg",
      "width": "600"
    }
  })])]), _c('a', {
    attrs: {
      "id": "index15"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "index15"
    }
  }), _c('a', {
    attrs: {
      "id": "index16"
    }
  }, [_c('em', [_vm._v("As you can see from this spectacular drone photograph over our estate, the natural beauty of the sugarbush in mid-autumn simply cannot be beat")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "index16"
    }
  })]), _c('a', {
    attrs: {
      "id": "index16"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index16"
    }
  }), _c('a', {
    attrs: {
      "id": "index17"
    }
  }, [_vm._v("And that’s what we want you to taste in this book—how extraordinarily inspiring, unique, and complex the story of maple syrup really is, and what part we’ve played in keeping the sugaring tradition alive. We want anyone who tastes our syrup to be able to appreciate it, to be awakened to the complexity and clarity of the flavor the second it hits their taste buds. But we also know that to truly appreciate the magic of maple syrup, you have to understand the history of the people who’ve processed it and the changing science and nature of making this product. ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("Part One")]), _vm._v(" will take you through the history of maple trees and maple sugaring in America, in the northeastern United States and beyond, from the indigenous uses of maple sap and sugar to what the settlers and early maple industrialists were able to achieve. We’ll explore the historical challenges of keeping up with the cane sugar industry, and the industrial tides of American progress in general, and how a new sense of environmental responsibility and economic viability has transformed the future of the maple industry. In "), _c('span', {
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(", we’ll get into the secrets of the trees themselves, and how we tap and process the sap from our trees here at Crown Maple. This is our deep dive into the botany, biology, and chemistry of maple syrup, and I’ve discovered that tapping old trees requires as complex a processing system as any in the environmental industry today. Finally, we’ll explore the beauty of maple syrup as a sweetener—its innate healthfulness, naturalness, and adaptability—and show you some of our favorite ways to put it to good use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index18"
    }
  }, [_vm._v("Crown Maple has been open almost five years now, and even with what our team has learned about this work, we’re still learning how to respond to the natural environment we’re working in, and to let it guide our business. We only get maybe a month—six weeks if we’re lucky—to tap, process, and store all of the hundreds of thousands of gallons of sap our trees produce. This is an industry of profound luck and blessing. If there is a place for us to be arrogant in this business, we haven’t found it yet. While we may have found the best technology to work with, and the best team to support us, we’re constantly learning from our colleagues in this business, producers both large and small across New England and Canada. And while we can do as much as possible to deliver for our customers, at the end of the day it’s still a question of what the trees are able to give us. Because it’s just that—a gift. And one of the primary upsides of entering this business when I did is that now I get to be an environmentalist the way I would want to be: with the resources to really make a big impact on the land around me. Every year, we learn new lessons about how to do this better. And in the process, we’ve come to care deeply about our product, from the tap to the evaporator to the barrel to the bottle, and out to you, the consumer.")])]), _c('a', {
    attrs: {
      "id": "index18"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "index18"
    }
  }), _c('a', {
    attrs: {
      "id": "index19"
    }
  }, [_vm._v("It’s only made life sweeter for us; let it be sweeter for you.")])]), _c('a', {
    attrs: {
      "id": "index19"
    }
  }), _c('p', {
    staticClass: "image1"
  }, [_c('a', {
    attrs: {
      "id": "index19"
    }
  }), _c('a', {
    attrs: {
      "id": "index20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/end.jpg",
      "width": "150"
    }
  })])]), _c('a', {
    attrs: {
      "id": "index20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5dde904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/intro.vue
// module id = 72
// module chunks = 0